var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 8C19.6875 7.48223 19.2678 7.0625 18.75 7.0625H1.25C0.732232 7.0625 0.3125 7.48223 0.3125 8C0.3125 8.51777 0.732232 8.9375 1.25 8.9375H18.75C19.2678 8.9375 19.6875 8.51777 19.6875 8Z",
    fill: "#EB9F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 1.75C19.6875 1.23223 19.2678 0.8125 18.75 0.8125H1.25C0.732232 0.8125 0.3125 1.23223 0.3125 1.75C0.3125 2.26777 0.732232 2.6875 1.25 2.6875H18.75C19.2678 2.6875 19.6875 2.26777 19.6875 1.75Z",
    fill: "#EB9F1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 14.25C19.6875 13.7322 19.2678 13.3125 18.75 13.3125H1.25C0.732232 13.3125 0.3125 13.7322 0.3125 14.25C0.3125 14.7678 0.732232 15.1875 1.25 15.1875H18.75C19.2678 15.1875 19.6875 14.7678 19.6875 14.25Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMenu);
export default __webpack_public_path__ + "static/media/sidebarMenu.ef90cc1bed591cb807287f0db2fe908b.svg";
export { ForwardRef as ReactComponent };